import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { apiProviders, responderAssignmentApiProviders } from './api.provider';
import { ASSIGNMENT_REPOSITORY_WEB_CONFIG } from './assignment-repository-web.config';
import { cachedProviders } from './cached-provider';
import { repositoryProviders, responderRepositoryProviders } from './repository.provider';
import { FormReleaseRepositoryWebModule } from '@module/form';
import { IdentityRepositoryWebModule } from '@module/user';
export var AssignmentRepositoryWebModule = /*#__PURE__*/function () {
  function AssignmentRepositoryWebModule() {
    _classCallCheck(this, AssignmentRepositoryWebModule);
  }

  _createClass(AssignmentRepositoryWebModule, null, [{
    key: "register",
    value: function register(config, formConfig) {
      return {
        module: AssignmentRepositoryWebModule,
        imports: [FormReleaseRepositoryWebModule.register(formConfig)],
        providers: [{
          provide: ASSIGNMENT_REPOSITORY_WEB_CONFIG,
          useValue: config
        }].concat(_toConsumableArray(apiProviders), _toConsumableArray(cachedProviders), _toConsumableArray(repositoryProviders)),
        exports: _toConsumableArray(repositoryProviders)
      };
    }
  }]);

  return AssignmentRepositoryWebModule;
}();
export var ResponderAssignmentRepositoryWebModule = /*#__PURE__*/function () {
  function ResponderAssignmentRepositoryWebModule() {
    _classCallCheck(this, ResponderAssignmentRepositoryWebModule);
  }

  _createClass(ResponderAssignmentRepositoryWebModule, null, [{
    key: "register",
    value: function register(config, formConfig, userConfig) {
      return {
        module: ResponderAssignmentRepositoryWebModule,
        imports: [FormReleaseRepositoryWebModule.register(formConfig), IdentityRepositoryWebModule.register(userConfig)],
        providers: [{
          provide: ASSIGNMENT_REPOSITORY_WEB_CONFIG,
          useValue: config
        }].concat(_toConsumableArray(responderAssignmentApiProviders), _toConsumableArray(cachedProviders), _toConsumableArray(responderRepositoryProviders)),
        exports: _toConsumableArray(responderRepositoryProviders)
      };
    }
  }]);

  return ResponderAssignmentRepositoryWebModule;
}();